var _defs, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoviseGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 259.74 333.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -14.68,
    y1: 52.55,
    x2: 273.87,
    y2: 142.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c3c7cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a6adb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#878f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#525c69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 79.05,
    y1: 230.99,
    x2: 79.72,
    y2: 230.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5b4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#818cf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7378f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5853e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4f46e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4b41dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4338ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4137c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3d34b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3730a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 54.88,
    y1: 136.8,
    x2: 13.81,
    y2: 265.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c4c9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a7adb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7c8491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 123.28,
    y1: 193.21,
    x2: 163.26,
    y2: 303.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#caced5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b0b6c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a1a8b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9ca3af"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.05,101.22l-32-14.8L8.59.5C4.52-1.24,0,1.74,0,6.17v73.86c0,7.6,4.53,14.47,11.52,17.47l189.92,81.39c46.13-19.08,58.44-36.9,58.18-50.65-.31-16.42-18.57-27.04-18.57-27.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.72 232.75 79.72 229.24 79.05 232.75 79.72 232.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m79.72,229.24v-52.88c0-6.89-4.06-13.14-10.35-15.95l-60-26.76c-4.4-1.96-9.37,1.26-9.37,6.08v72.47c0,44.56,79.72,17.04,79.72,17.04Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.63,218.99v-90.74h0c.26,13.75-12.05,31.57-58.18,50.65l-100.69,41.64-.12.05-7.66,3.17h0s-10.66,4.41-10.66,4.41h0s-2.59,1.07-2.59,1.07c0,0-79.72,27.52-79.72-17.04v69.48c0,5.43.52,10.85,1.76,16.14,5.73,24.43,24.04,48.95,78.87,26.27l121.87-50.4h-1.05c63.59-26.73,58.19-54.7,58.19-54.7Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoviseGray);
export default __webpack_public_path__ + "static/media/dovise-gray.c3e1c9f811abc021e174b1580e10b8b5.svg";
export { ForwardRef as ReactComponent };